import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentFocusField } from '../store/selectors';
import { setCurrentFocusField } from '../store/slice';

type FlashBackgroundProps = {
    id: string;
};

function FlashBackground({ id }: FlashBackgroundProps): JSX.Element {
    const dispatch = useDispatch();
    const currentFocusField = useSelector(selectCurrentFocusField);

    const [flash, setFlash] = useState(false);

    useEffect(() => {
        const isFocused = currentFocusField?.id === id && currentFocusField?.playAnimation;

        if (isFocused) {
            setFlash(true);
            setTimeout(() => {
                dispatch(setCurrentFocusField(undefined));
            }, 500);
        } else {
            setFlash(false);
        }
    }, [currentFocusField, dispatch, id]);

    return (
        <AnimatePresence initial={false}>
            {flash && (
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0, transition: { duration: 0.5 } }}
                    animate={{ opacity: 0.4, transition: { duration: 0.05 } }}
                    className="w-full h-full rounded-[5px] border-2 border-indigo-600 bg-indigo-200 absolute z-50 top-0 left-0"
                />
            )}
        </AnimatePresence>
    );
}

export default FlashBackground;
